import { PromoProductCard } from './PromoProductCard'
import { ProductCardSkeleton } from '../../../UiBlocks'
import { usePromo } from '../../state'


const GRID_CLASSES = 'grid grid-cols-2 md:grid-cols-5 xl:grid-cols-5 gap-4 mt-5 mb-5 bg-cards-bg p-4'

const SKELETON_COUNT = 5

/**
 * ItemsByDiscount - Renders promo product grids by discount level.
 *
 * Level 1: Shows first category products only.
 * Level 2: Shows first + second category products.
 *
 * All data comes pre-mapped from PromoProvider context.
 */
export function ItemsByDiscount() {
  const { firstCategoryProducts, secondCategoryProducts, level, loading } = usePromo()

  if (loading) {
    return (
      <div className={GRID_CLASSES}>
        {Array.from({ length: SKELETON_COUNT }, (_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (firstCategoryProducts.length === 0) return null

  return (
    <div className={GRID_CLASSES}>
      {firstCategoryProducts.map((promoProduct) => (
        <PromoProductCard
          key={promoProduct.product.id}
          promoProduct={promoProduct}
        />
      ))}
      {level === 2 &&
        secondCategoryProducts.map((promoProduct) => (
          <PromoProductCard
            key={promoProduct.product.id}
            promoProduct={promoProduct}
          />
        ))}
    </div>
  )
}
